<main>
  <div class="container container-width">
    <div class="topheadtitle">
      <h4>
        Agency Summary Report
        @if (showReportResults) {
          <span>{{ enddate ? 'From' : '-' }} {{ startdate }} {{ enddate ? 'To' : '' }} {{
          enddate }}</span>
        }
      </h4>
    </div>

    @if (!showReportResults) {
      <div class="form-box w-100 d-flex p-2" aria-labelledby="creationdate-legend"
        aria-describedby="creationdate-hint">
        <!-- Group label -->
        <span id="creationdate-legend" class="mr-1">Creation Date</span>
        <input class="mr-1" id="creationStart" [(ngModel)]="startdate" type="date" [max]="today" title="Start date"
          aria-labelledby="creationdate-legend" />
          <span class="mr-1" aria-hidden="true">to</span>
          <input class="mr-1" id="creationEnd" [(ngModel)]="enddate" type="date" [max]="today" title="End date"
            aria-labelledby="creationdate-legend" />
            <span id="creationdate-hint" class="mr-1">
              Enter just one date if a single date is desired.
            </span>
          </div>
          <div class="mt-3">
            <button type="button" class="btn btn-primary btn-sm" (click)="generateReport()">Generate Report</button>
            <button type="button" class="btn btn-primary btn-sm ml-3"
            (click)="startdate = '';enddate =''">Reset</button>
          </div>
        }

        @if (showReportResults) {
          <div class="table-container">
            @if (outPut.length > 0) {
              <button type="button" class="btn btn-primary btn-sm mb-1" (click)="excelExport()">
                Export To Excel
              </button>
            }
            <table class="table">
              <caption>Agency Summary Report</caption>
              <thead>
                <tr>
                  <th scope="col" rowspan="2" class="align-middle">Issued By</th>
                  <th scope="col" rowspan="2" class="align-middle">Queued</th>
                  <th scope="col" rowspan="2" class="align-middle">Rejected</th>
                  <th scope="col" rowspan="2" class="align-middle">Failed</th>
                  <th scope="col" class="tb" colspan="7">Delivered</th>
                  <th scope="col" rowspan="2" class="align-middle">Total</th>
                </tr>
                <tr class="tb">
                  <th scope="col">DNR</th>
                  <th scope="col">DAIT-PROTECT</th>
                  <th scope="col">COWS</th>
                  <th scope="col">CCAP</th>
                  <th scope="col">MUNICIPAL COURT</th>
                  <th scope="col">LOCAL COURT</th>
                  <th scope="col">NO ACTION</th>
                </tr>
              </thead>
              <tbody>
                @for (item of getItems(); track item) {
                  <tr>
                    <td>{{item.agencyName}}</td>
                    <td>{{item.queued}}</td>
                    <td>{{item.rejected}}</td>
                    <td>{{item.failed}}</td>
                    <td>{{item.dnr}}</td>
                    <td>{{item.protect}}</td>
                    <td>{{item.cows}}</td>
                    <td>{{item.ccap}}</td>
                    <td>{{item.muni}}</td>
                    <td>{{item.ccap}}</td>
                    <td>{{item.noAction}}</td>
                    <td>{{item.total}}</td>
                  </tr>
                }
              </tbody>
            </table>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <span>{{outPut.length}} items found, displaying {{getCurrentPageTotal()}} of {{outPut.length}}</span>
              </div>
              <ngb-pagination [collectionSize]="outPut.length" [(page)]="currentPage" [ellipses]="true" [maxSize]="10"
                (pageChange)="onPageChange(currentPage)" [pageSize]="10" [boundaryLinks]="true"
              aria-label="Agency summary pagination"></ngb-pagination>
              <br />
              <button type="button" class="btn btn-outline-primary" (click)="showReportResults = false;">
                Go back to previous page
              </button>
            </div>
          </div>
        }
      </div>
    </main>